import React, { useEffect, useState } from "react";
import axios, { CancelToken } from "axios";
import { useHistory } from "react-router-dom";

import { StatusCode } from "api/protocols";

import { showError } from "redux/actions/ui";
import { ITemplate } from "redux/reducers/models/reservations";
import { useAppDispatch } from "hooks/redux";

import Page from "components/page/Page";
import DataTable from "../../../../../components/dataTable/DataTable";
import { GetReservationTemplate } from "api/rpc/2024-04/facilityAdmin/reservation/reservation";

import { useTranslation } from "react-i18next";

const CURRENT_URL = "/admin/settings/reservations/templates";
export default function ReservationTemplates() {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const [templates, setTemplates] = useState<ITemplate[]>(undefined);

  useEffect(() => {
    const source = axios.CancelToken.source();
    void loadTemplates(source.token);
    return () => source.cancel();
  }, []);

  async function loadTemplates(token?: CancelToken) {
    if (templates !== undefined) {
      setTemplates(undefined);
    }
    const templateRes = await GetReservationTemplate(null, token ? false : true, token);

    if (token && token.reason) {
      return;
    }
    if (templateRes.status !== StatusCode.OK) {
      dispatch(showError(t("Error loading activity templates")));
    }

    const loadedTemplates: ITemplate[] =
      templateRes.status === StatusCode.OK && Array.isArray(templateRes.data) ? (templateRes.data as ITemplate[]) : [];
    setTemplates(loadedTemplates);
  }

  const primaryAction = {
    content: t("New Template"),
    action: () => history.push(CURRENT_URL + "/new"),
  };

  return (
    <Page
      narrow
      title={t("Activity Templates")}
      primaryAction={primaryAction}
    >
      <DataTable
        columns={[
          { label: t("Name") },
          { label: t("Version") },
          { label: t("Activity Type") },
        ]}
        loading={templates === undefined}
      >
        {templates?.map(template => {
          return (
            <tr
              key={template.id}
              onClick={() => history.push(CURRENT_URL + `/${String(template.id)}`)}
              className="clickable"
            >
              <td>{template.name}</td>
              <td>{template.version}</td>
              <td>{template.module?.title}</td>
            </tr>
          );
        })}
      </DataTable>
    </Page>
  );
}
